<template>
  <div class="main">
    <div class="title">
      <div class="name">专家预约信息</div>
      <div class="btn" @click="$router.back()">
        <img src="../../../assets/images/back.png" alt="">
        返回
      </div>
    </div>

    <div class="box">
      <div class="detail">
        <div class="img">
          <img :src="urlStr + detail.pic" alt="">
        </div>
        <div class="cont">
          <div class="name-box">
            <div class="name">
              <b>{{detail.name}}</b>
              <i>|</i>
              <span>{{detail.type_name}}</span>
            </div>
            <div class="num-box">
              <p>预约总数<b>{{detail.yuyue_all_count}}</b></p>
              <span>|</span>
              <p>待处理<b>{{detail.yuyue_count}}</b></p>
            </div>
          </div>
          <div class="tex ovHide">{{detail.job_text}}</div>
          <div class="xian"></div>
          <div class="tex ovHide2" v-html="detail.desc"></div>
        </div>
      </div>
    </div>

    <div style="width: 100%;height: 20px;"></div>

    <div class="box">
      <div class="search-box">
        <div class="input-box">
          <el-input v-model="input" placeholder="请输入专家姓名" style="width: 100%;"></el-input>
          <div @click="listFun">
            <i class="iconfont icon-sousuo"></i>
            <span>搜索</span>
          </div>
        </div>
      </div>
      <div class="list">
        <div class="item" v-for="item in List" :key="item.id">
          <div class="item-name">
            <div class="iten-b">{{item.name}}</div>
            <div class="item-r">
              <span class="s1" v-if="Number(item.status) === 0" @click="changeFun(item.id)">未处理</span>
              <span class="s3" v-if="Number(item.status) === 1">已处理</span>
              <span class="s2" v-if="Number(item.status) === 1" @click="delFun(item.id)">删除</span>
            </div>
          </div>
          <div class="text">
            <span>申请时间：</span>
            <span>{{item.create_time}}</span>
          </div>
          <div class="text">
            <span>联系电话：</span>
            <span>{{item.phone}}</span>
          </div>
          <div class="text">
            <span>申请内容：</span>
            <span class="ovHide2">{{item.content}}</span>
          </div>
        </div>
        <el-empty :image-size="200" v-if="List.length == 0" style="margin: 0 auto"></el-empty>
      </div>
    </div>
  </div>
</template>
<script>
import {changeStatus, delYuyue, expertYuyue, getExpert} from "@/api/index";
import {urlStr} from "@/config";
export default {
  name: "detail",
  data() {
    return {
      urlStr: urlStr,
      id  :'',
      input:'',
      detail:{},
      List:[]
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {},
  created() {
    this.$emit("setActive", {
      active: 1,
      act: 2,
      name: '专家管理 > 专家信息 > 预约信息'
    })
    this.id = this.$route.query.id
    this.detailFun()
    this.listFun()
  },
  methods: {
    // 获取列表
    async listFun(){
      let _res = await expertYuyue(
          this.user.mid,
          this.id,
          this.input,
          1,9999
      );
      if (_res.status === 200) {
        this.List = _res.data.list
      } else {
        this.$message.error(_res.msg)
      }
    },

    // 获取专家详情
    async detailFun() {
      let _res = await getExpert(
          this.user.mid,
          this.id
      );
      if (_res.status === 200) {
        this.detail = _res.data
        let ary = JSON.parse(this.detail.job)
        let arr = []
        ary.map(itm => {
          arr.push(itm.value)
        })
        this.detail.job_text = arr.join('、')
      } else {
        this.$message.error(_res.msg)
      }
    },


    async changeFun(id){
      let _res = await changeStatus(
          this.user.mid,id
      );
      if (_res.status === 200) {
        this.$message.success(_res.msg)
        this.listFun()
      } else {
        this.$message.error(_res.msg)
      }
    },

    async delFun(id){
      let _res = await delYuyue(
          this.user.mid,id
      );
      if (_res.status === 200) {
        this.$message.success(_res.msg)
        this.listFun()
      } else {
        this.$message.error(_res.msg)
      }
    }

  },
  watch: {

  },
  filters: {}
}
</script>

<style scoped lang="scss">

.main {
  display: flex;
  flex-direction: column;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 8px 15px 8px;
    .name {
      font-size: 20px;
      color: #ffffff;
      font-weight: bold;
    }
    .btn {
      width: 100px;
      height: 40px;
      background-color: #ffffff;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      letter-spacing: 1px;
      color: #0a2240;
      cursor: pointer;
      img {
        width: 14px;
        height: 12px;
        margin-right: 2px;
      }
    }
  }
  .box {
    width: 100%;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 20px;
    flex: 1;
    .list {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .item {
        width: 305px;
        height: 194px;
        background-color: #ffffff;
        border-radius: 10px;
        border: solid 1px #dae0e6;
        padding: 15px;
        margin-right: 20px;
        margin-bottom: 20px;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .text {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          margin-top: 15px;
          span:first-child {
            width: 75px;
            font-size: 14px;
            color: #666666;
          }
          span:last-child {
            flex: 1;
            width: 0;
            font-size: 14px;
            color: #666666;
          }
        }
        .item-name {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 15px;
          border-bottom: 1px solid #eeeeee;
          .iten-b {
            font-size: 20px;
            color: #333333;
            font-weight: bold;
          }
          .item-r {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .s1 {
              width: 80px;
              height: 30px;
              background-color: #0a2240;
              border-radius: 15px;
              text-align: center;
              line-height: 30px;
              font-size: 14px;
              letter-spacing: 1px;
              color: #ffffff;
              cursor: pointer;
            }
            .s2 {
              width: 80px;
              height: 30px;
              background-color: #ffffff;
              border-radius: 15px;
              border: solid 1px #0a2240;
              line-height: 28px;
              text-align: center;
              letter-spacing: 1px;
              color: #0a2240;
              font-size: 14px;
              cursor: pointer;
            }
            .s3 {
              font-size: 14px;
              letter-spacing: 1px;
              color: #999999;
              margin-right: 5px;
            }
          }
        }
      }
    }

    .search-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      .select-box {
        width: 162px;
      }
      .chongz {
        width: 99px;
        height: 40px;
        background-color: #0a2240;
        border-radius: 5px;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
        text-align: center;
        line-height: 40px;
      }
      .input-box {
        flex: 1;
        width: 0;
        display: flex;
        height: 40px;
        overflow: hidden;
        justify-content: space-between;
        border-radius: 5px;

        > div {
          width: 100px;
          height: 40px;
          background-color: #0a2240;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          span {
            font-size: 16px;
            color: #ffffff;
          }
          i {
            margin-right: 4px;
            color: #ffffff;
            font-size: 18px;
          }
        }
      }
    }
    .detail {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .img {
        width: 127px;
        height: 154px;
        background-color: #eaeff3;
        border-radius: 10px;
        img {
          width: 100%;
          height: 100%;
          object-fit: scale-down;
        }
      }
      .cont {
        flex: 1;
        width: 0;
        margin-left: 27px;
        .name-box {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          .name {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            b {
              font-size: 28px;
              letter-spacing: 1px;
              color: #333333;
              font-weight: bold;
            }
            i {
              color: #e2e2e2;
              margin: 0 20px;
            }
            span {
              font-size: 18px;
              letter-spacing: 1px;
              color: #333333;
            }
          }
          .num-box {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            p {
              font-size: 18px;
              color: #0a2240;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              b {
                font-size: 27px;
                color: #ff9600;
                font-weight: bold;
                margin-left: 20px;
              }
            }
            span {
              color: #e2e2e2;
              margin: 0 50px;
            }
          }
        }
        .tex {
          width: 100%;
          font-size: 14px;
          color: #666666;
          line-height: 22px;
        }
        .xian {
          width: 100%;
          height: 1px;
          background-color: #eaeaea;
          margin: 15px 0;
        }
      }
    }
  }
}
</style>


